import { makeStyles, DefaultTheme } from '@material-ui/styles';
import cn from 'clsx';
import Text from '../../Text';
import OverflowTooltip from '../../OverflowTooltip';

type UserFullNameProps = {
    firstName: string;
    lastName: string;
    clamp?: number | 'none' | 'inherit';
    className?: string;
    variant?: keyof DefaultTheme['typography'];
    onClick?: () => void;
};

const constructFullName = (firstName: string, lastName: string): string => {
    const nameArray = [firstName, lastName].filter(Boolean);
    const fullName = nameArray.join(' ');

    if (!fullName) {
        return 'Participant';
    }

    return fullName;
};

const UserFullName: React.FC<UserFullNameProps> = ({
    firstName = '',
    lastName = '',
    className,
    clamp = 1,
    variant = 't60',
    onClick = () => {},
}) => {
    const fullName = constructFullName(firstName, lastName);
    const classes = useStyles();

    return (
        <OverflowTooltip content={fullName}>
            <Text
                className={cn(classes.text, className)}
                variant={variant}
                clamp={clamp}
                onClick={onClick}
            >
                {fullName}
            </Text>
        </OverflowTooltip>
    );
};

const useStyles = makeStyles(
    () => ({
        text: {
            maxWidth: '100%',
            wordBreak: 'break-all',
        },
    }),
    { classNamePrefix: 'user-fullname' }
);

export default UserFullName;
